<input class="input-color" type="color" (change)="HandlerChange($event)">